import { GDFPalletCode, GDFSubRecord, GDFSubRecordType } from '../../gdf/type';
import WmoVolcanoAshCloud2Tooltip from './components/WmoVolcanoAshCloud2Tooltip';

export function TooltipFromSubRecord(props: { productId: number; palette: GDFPalletCode; item: GDFSubRecord }) {
    const { item } = props;

    if (item.type === GDFSubRecordType.wmoAshCloud2) {
        return <WmoVolcanoAshCloud2Tooltip record={item} />;
    }

    return null;
}
